import React from 'react';
import { Bar } from 'react-chartjs-2';

export default ({ feed }) => {
    return (
        <div>
            <div className="dashboard-bar">
                <Bar
                    data={{
                        title: 'Cost Breakdown',
                        mobileTitle: '250',
                        mobileDescription: 'Events over $10k',
                        labels: ['< $5k', '$5k-$10k', '$10k+'],
                        datasets: [
                            {
                                data: [
                                    feed.costUnder5k,
                                    feed.cost5k10k,
                                    feed.costOver10k
                                ],
                                label: '# of Events',
                                backgroundColor: [
                                    '#AF1F29',
                                    '#9DA4AC',
                                    '#E5E5E5'
                                ]
                            }
                        ]
                    }}
                    options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: {
                            display: false
                        }
                    }}
                />
            </div>
            <div className="dashboard-title-desktop">Cost Breakdown</div>
            <div className="dashboard-title-mobile dashboard-title-mobile__bar">
                <span className="dashboard-title-value">
                    {feed.costOver10k}
                </span>
                Events over $10k
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/dashboard/cost-breakdown.js